import React, { useRef, useEffect } from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";

const RiskFactorTreeChart = (props) => {
  const riskWiseChart = Array.isArray(props?.homePageCharts) ? props.homePageCharts : [];
// Predefined colors for Risk categories
const riskColors = {
    "Smoking": "#001c58",
    "Celiac Disease": "#004f88",
    "Additional details": "#0070c0",
    "Mental Health Disorders": "#00b0f0",
    "Thyroid Disorder": "#00a4c9",
    "Other risks": "#8ec5d5",
  };

  const riskWiseData = riskWiseChart
    .filter(item => item.indiacatorname.includes('Risk Factor'))
    .map(item => {
     const indicator = item.indiacatorname.split('Risk Factor')[0].split('-')[0];
     return {name:indicator, value: item.count, color: riskColors[indicator] || '#cccccc' }; // Default color if not found
});

  const treechart = {
    chart:{
        backgroundColor: null,
    },
    colorAxis: {
        minColor: '#FFFFFF',
        backgroundColor: null,
        maxColor: Highcharts.getOptions().colors[0]
    },
    series: [{
        type: 'treemap',
        backgroundColor: null,
        layoutAlgorithm: 'squarified',
        clip: false,
        data: riskWiseData
    }],
    
    title: {
        text: ''
    }
,
credits:{
    enabled: false,
    },
    plotOptions: {
        treemap: {
            dataLabels: {
                style: {
                    textShadow: 'none' // Removing text shadow
                }
            }
        }
    }
}
  return <HighchartsReact 
  highcharts={Highcharts} 
  options={treechart} />;
};

export default RiskFactorTreeChart;